<template>
  <div ref="mainContainer">
    <div class="relative h-full">
      <item-v2-item-widget
          v-if="activeWidget === 'items' && (isWeddingRing || session.items.length > 1)"
          :session="session"
          @show-step-widget="showStepWidget"
          @delete-item="deleteItem"
      />
      <step-widget-conf
          v-else-if="isWeddingRing"
          :session="session"
          :item-idx="itemIdx"
          @delete-item="deleteItem"
          @add-item="addItem"
      />
      <step-widget v-else :show="session.items[itemIdx]?.diamond_exchange">
        <div v-if="session.items.length > 1" @click="activeWidget = 'items'"
             class="flex items-center space-x-2 cursor-pointer h-full px-4 border-r border-gray-100 hover:bg-gray-50 transition-colors">
          <div v-for="(item, idx) in session.items" :key="item.item_number || idx"
               class="w-8 h-8 lg:w-10 lg:h-10 rounded-full border border-gray-200 overflow-hidden bg-white shrink-0 relative"
               :class="{'ring-2 ring-brand-main': itemIdx == idx}">
            <img v-if="item.image.filename_layer" :src="item.image.filename_layer"
                 class="absolute insert-0 w-auto h-full aspect-square object-cover"
                 alt="Setting image"/>

            <img :src="item.image.filename" class="w-full h-full object-cover" alt=""/>
          </div>
        </div>
      </step-widget>
      <template v-if="viewMode == 'set'">
        <item-v2-shop-the-look
            :session="session"
            @patch-set="(event) => patchSet(event.value, event.items)"
        />
      </template>
      <template v-else-if="viewMode == 'item' && session.items && session.items[itemIdx]">
        <div class="view-mode-item-container">
          <div class="flex flex-col lg:flex-row w-screen relative">
            <div class=" z-30 top-0 flex-2"
                 :class="{'sticky': !isWeddingRing}">
              <!-- image grid -->
              <item-v3-image-grid-wedding-rings
                  v-if="isWeddingRing"
                  class="sticky z-40 top-0 bg-white aspect-4/3 lg:aspect-auto lg:h-auto"
                  :image="mainImage"
                  :item-number="session.items[itemIdx].item_number"
                  :image-idx="imageIdx"
                  :popup-image="popupImage"
                  @switchImage="(event: any) => imageIdx = event"
                  @popupImage="(event: any) => popupImage = event"
              />
              <item-v2-image-grid
                  v-else
                  class="sticky z-40 top-0 bg-white aspect-4/3 lg:aspect-auto lg:h-auto"
                  :image="mainImage"
                  :item-number="session.items[itemIdx].item_number"
                  :engraving="session.engravings[itemIdx].inside"
                  :image-idx="imageIdx"
                  :popup-image="popupImage"
                  @switchImage="(event: any) => imageIdx = event"
                  @popupImage="(event: any) => popupImage = event"
              />
              <div class="bg-white lg:hidden border-b border-t border-gray-200 py-2 px-4 flex justify-between">
                <div
                    v-if="(configureAll ? setPrice : session.items[itemIdx].price.total) > 0"
                    class="text-xl tracking-tight text-gray-900"
                >
                  {{ $n(configureAll ? setPrice : session.items[itemIdx].price.total, "currency") }}
                </div>
                <div>
                  <ul class="flex">
                    <li @click="imageIdx = '-1'" class="py-2 px-1">
                      <div
                          class="border-gray-900 rounded-full w-3 h-3 border"
                          :class="{
                'bg-gray-900': imageIdx == '-1',
                  }"
                      ></div>
                    </li>
                    <li v-if="session.engravings[itemIdx].inside.text != ''" @click="imageIdx = 'Engraving'"
                        class="py-2 px-1">
                      <div
                          class="border-gray-900 rounded-full w-3 h-3 border"
                          :class="{
                'bg-gray-900': imageIdx == 'Engraving',
                  }"
                      ></div>
                    </li>
                    <li
                        v-for="(image_pos, image_pos_idx) in session.items[itemIdx].image.positions"
                        :key="image_pos.filename"
                        @click="imageIdx = image_pos_idx.toString()"
                        class="py-2 px-1"
                    >
                      <div
                          class="border-gray-900 rounded-full w-3 h-3 border"
                          :class="{
                'bg-gray-900': imageIdx == image_pos_idx.toString(),
                  }"

                      ></div>
                    </li>
                  </ul>
                </div>
                <div class="flex">
                  <!-- image icon -->
                  <svg @click="popupImage=true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                       stroke-width="1.5" stroke="currentColor" class="w-5 pt-0.5 cursor-pointer mr-4">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"/>
                  </svg>

                  <!-- share icon -->
                  <svg @click="onShare" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                       stroke-width="1.5"
                       stroke="currentColor" class="w-5 pt-0.5 cursor-pointer mr-4" :aria-label="$t(pageStr + '.share')"
                       role="button">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"/>
                  </svg>

                  <!-- wishlist icon -->
                  <svg @click="toggleItemOnWishList" v-if="!isOnWishlist" xmlns="http://www.w3.org/2000/svg"
                       fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                       stroke="currentColor" class="w-6 cursor-pointer  text-brand-text">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
                  </svg>
                  <svg @click="toggleItemOnWishList" v-else xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                       viewBox="0 0 24 24" stroke-width="1.5"
                       stroke="currentColor" class="w-6 cursor-pointer  text-brand-text">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
                  </svg>

                </div>
              </div>
            </div>
            <div class="flex-1 md:min-w-[480px] md:px-4 space-y-4 md:pt-0 z-10 pb-4"
                 :class="{ 'bg-parameter-bg': isWeddingRing }">
              <!-- side menu -->
              <div class="sticky top-32 z-10">
                <div
                    class="px-4 flex flex-col justify-center top-0 z-40 pt-2 pb-2"
                    :class="{'bg-parameter-bg': isWeddingRing, 'bg-white': !isWeddingRing}"
                >
                  <!-- Title and price -->
                  <p
                      class="grow text-base tracking-tight text-gray-900 sm:text-2xl sm:pr-14 font-ivymode"
                  >
                    {{ session.items[itemIdx].desc.short_title }}
                  </p>
                  <div class="hidden sm:flex w-full items-center justify-start gap-x-2 mt-2 ">
                    <p
                        v-if="(configureAll ? setPrice : session.items[itemIdx].price.total) > 0"
                        class="text-2xl tracking-tight text-gray-900 mb-2 text-right italic"
                    >
                      {{ $n(configureAll ? setPrice : session.items[itemIdx].price.total, "currency") }}
                    </p>
                    <p class="ml-2 text-base text-brand-main font-light">{{ $t(pageStr + '.incl_vat') }}</p>
                    <div class="hidden lg:flex space-x-2">
                      <div class="rounded-full bg-brand-main w-9 h-9 text-white flex justify-center items-center">
                        <!-- share icon -->
                        <svg @click="onShare" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                             stroke-width="1.5"
                             stroke="currentColor" class="w-6 mx-auto cursor-pointer"
                             :aria-label="$t(pageStr + '.share')"
                             role="button">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"/>
                        </svg>
                      </div>
                      <div class="w-9 h-9 text-white flex justify-center items-center">
                        <!-- wishlist icon -->
                        <svg @click="toggleItemOnWishList" v-if="!isOnWishlist" xmlns="http://www.w3.org/2000/svg"
                             fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" class="w-6 cursor-pointer  text-brand-main">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
                        </svg>
                        <svg @click="toggleItemOnWishList" v-else xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                             viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" class="w-6 cursor-pointer  text-brand-main">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div v-if="false" class="hidden sm:flex w-24 h-full content-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="w-7 pt-0.5 cursor-pointer  hover:text-brand-main">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
                    </svg>

                  </div>
                </div>
                <div v-if="session.items[itemIdx].facts.item_type !== 'wedding_ring'" class="px-4 xl:flex py-4">
                  <item-v2-stone-type
                      :stone-types="getStoneTypes"
                      @patch="(event) => patch(event.action, event.value, event.certificated_diamond)"
                  ></item-v2-stone-type>

                </div>
                <div v-if="showEngraving" class="block space-y-4 w-screen px-4 md:w-full pb-4">
                  <div @click="showEngraving = false" class="flex items-center cursor-pointer w-full">
                    <div class="grow">
                    <span class="font-bold block text-black pr-1 text-xs">{{
                        $t(pageStr + '.article_configuration')
                      }}</span>
                    </div>
                    <div class="shrink-0 w-6 cursor-pointer text-brand-main">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-4 h-4 transition-transform duration-300"
                          :class="{ 'rotate-180': !showEngraving }"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                      >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <item-v3-variants-conf
                    v-if="!showEngraving && session.items[itemIdx].facts.item_type === 'wedding_ring'"
                    :item-idx="itemIdx"
                    :item="session.items[itemIdx]"
                    :session-id="session.session_id"
                    @patch="(event) => patch(event.action, event.value, event.certificated_diamond)"
                    @hover="(image) => hoveredVariantImage = image"
                />
                <item-v2-variants
                    v-else-if="!showEngraving"
                    :item="session.items[itemIdx]"
                    :item-idx="itemIdx"
                    :session-id="session.session_id"
                    @patch="(event) => patch(event.action, event.value, event.certificated_diamond)"
                />
                <template v-if="session.items[itemIdx].engraving">
                  <div v-if="!isWeddingRing" class="block space-y-4 w-screen px-4 md:w-full mt-4 border-b border-gray-100 pb-4">
                    <div @click="showEngraving = !showEngraving" class="flex items-center cursor-pointer w-full">
                      <div class="grow">
                      <span class="font-bold block text-black pr-1 text-xs">{{
                          $t(pageStr + '.engraving')
                        }}</span>
                      </div>
                      <div class="lex-shrink-0 w-6 cursor-pointer text-brand-main">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4 transition-transform duration-300"
                            :class="{ 'rotate-180': showEngraving }"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div v-if="showEngraving" ref="engravingEl" class="mt-4">
                    <item-v2-engraving
                        :engraving="session.engravings[itemIdx].inside"
                        @update:engraving="(event) => session.engravings[itemIdx].inside = event"
                        @patch="(event) => patch(event.action, event.value, event.certificated_diamond, true)"
                        @switch:image="(event) => imageIdx = event.toString()"
                    />
                  </div>
                </template>
                <div class="my-4 space-y-4 w-full px-4">
                  <item-v2-name
                      v-if="!isWeddingRing"
                      @patch="(event) => patch(event.action, event.value, event.certificated_diamond, true)"
                  />

                </div>
                <div class="my-4 space-y-4 w-full px-4 border-brand-main border-t pt-4">
                  <div v-if="session.items[itemIdx].diamond_exchange">
                  <span v-if="!isDiamondExchangeUsable"
                        class="block w-full text-white bg-brand-main opacity-50 p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                  >
                    {{ $t(pageStr + '.select_stone_from_diamond_exchange_inactive') }}
                  </span>
                    <a v-else
                       class="block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                       @click="addCertificatedDiamond()"
                    >{{ $t(pageStr + '.select_stone_from_diamond_exchange') }}</a
                    >
                  </div>
                  <a
                      v-if="false"
                      class="cursor-pointer block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                      @click="viewMode = 'set'; itemIdx = 0"
                  >{{ $t(pageStr + '.complete_your_look') }}</a
                  >

                  <a
                      href="/partner"
                      class="block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                  >{{ $t(pageStr + '.consult_at_location') }}</a
                  >
                  <a
                      @click="printout()"
                      class=" cursor-pointer block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                  >{{ $t(pageStr + '.printout') }}</a
                  >
                  <form
                      v-if="Config.getShopUrl() !== ''"
                      method="post"
                      :action="Config.getShopUrl()"
                      target="_blank"
                      ref="orderForm"
                  >
                    <button
                        type="button"
                        @click="createOrder()"
                        class="block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                    >
                      <template v-if="Config.getShopUrlButtonText() !== ''">
                        {{ Config.getShopUrlButtonText() }}
                      </template>
                      <template v-else>
                        {{ $t(pageStr + '.dealer_login') }}
                      </template>
                    </button>
                    <input type="hidden" name="lang" value="de"/>
                    <input type="hidden" name="action" value="order"/>
                    <input type="hidden" name="order" :value="orderData"/>
                  </form>
                  <form
                      v-else-if="session.items[itemIdx].item_number.includes('R-')"
                      method="post"
                      action="https://www.rubin-ec84.de:7004/store/faces/login.xhtml"
                      target="_blank"
                      ref="orderForm"
                  >
                    <button
                        type="button"
                        @click="createOrder()"
                        class="block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                    >
                      {{ $t(pageStr + '.dealer_login') }}
                    </button>
                    <input type="hidden" name="lang" value="de"/>
                    <input type="hidden" name="action" value="order"/>
                    <input type="hidden" name="order" :value="orderData"/>
                  </form>
                  <form
                      v-else-if="session.items[itemIdx].item_number.includes('S-') && isSecureConftecHost"
                      method="post"
                      action="https://secure.conftec.com/order/sales/site_index.php"
                      target="_blank"
                      ref="orderForm"
                  >
                    <button
                        type="button"
                        @click="createOrder()"
                        class="block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
                    >
                      {{ $t(pageStr + '.dealer_login') }}
                    </button>
                    <input type="hidden" name="lang" value="de"/>
                    <input type="hidden" name="action" value="order"/>
                    <input type="hidden" name="order" :value="orderData"/>
                  </form>
                </div>
              </div>

            </div>
          </div>
          <div class="w-screen relative">
            <description-parts
                :items="descriptionItems"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, nextTick, onMounted, onUnmounted, provide, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {Sessions} from "@/assets/ts/sessions";
import DescriptionParts from "@/components/description/descriptionParts.vue";
import ItemV2ImageGrid from "@/components/itemV2/itemV2ImageGrid.vue";
import ItemV3ImageGridWeddingRings from "@/components/itemV3/itemV3ImageGridWeddingRings.vue";
import ItemV2Variants from "@/components/itemV2/itemV2Variants.vue";
import ItemV3VariantsConf from "@/components/itemV3/itemV3VariantsConf.vue";
import ItemV2Engraving from "@/components/itemV2/itemV2Engraving.vue";
import ItemV2StoneType from "@/components/itemV2/itemV2StoneType.vue";
import ItemV2ShopTheLook from "@/components/itemV2/itemV2ShopTheLook.vue";
import ItemV2Name from "@/components/itemV2/itemV2Name.vue";
import StepWidget from "@/components/stepWidget.vue";
import StepWidgetConf from "@/components/stepWidgetConf.vue";
import ItemV2ItemWidget from "@/components/itemV2/itemV2ItemWidget.vue";
import ItemV3Engraving from "@/components/itemV3/parameter/itemV3Engraving.vue";
import {Config} from "@/assets/ts/config";

const store = useStore();
const {t} = useI18n();
const route = useRoute();
const router = useRouter();
const error = ref(0);

const session = ref(store.getters["session/get"]);

const itemIdx = computed({
  get: () => store.getters["session/getItemIdx"],
  set: (val) => store.commit("session/setItemIdx", val)
});
const activeWidget = ref("step");
const popupImage = ref(false);
const showEngraving = ref(false);

// Whether the current item is a wedding ring - wedding rings always use the itemV3
// variants configurator and engraving components; other item types use the itemV2 ones.
const isWeddingRing = computed(() => session.value.items[itemIdx.value]?.facts?.item_type === 'wedding_ring');

const configureAll = computed(() => store.getters["session/getConfigureAll"]);

// For wedding rings, show the description/details of all items (the pair); otherwise only the current item.
const descriptionItems = computed(() => {
  const currentItem = session.value.items[itemIdx.value];
  if (!currentItem) return [];

  const toDescriptionItem = (item: any) => ({
    itemPrice: item.price,
    itemNumber: item.item_number,
    description: item.desc.title,
    partsList: item.desc.parts,
  });

  if (isWeddingRing.value && session.value.items.length > 1) {
    return session.value.items.map(toDescriptionItem);
  }

  return [toDescriptionItem(currentItem)];
});

const setPrice = computed(() => {
  let total = 0;
  if (session.value.items) {
    for (const item of session.value.items) {
      total += item.price?.total || 0;
    }
  }
  return total;
});
const hoveredVariantImage = ref<any>(null);
const mainContainer = ref<HTMLElement | null>(null);
const engravingEl = ref<any | null>(null);
const pageStr = "components.itemV2.itemV2Main"

const viewMode = computed({
  get: () => store.getters["session/getViewMode"],
  set: (val) => store.commit("session/setViewMode", val)
});

const mainImage = computed(() => {
  const currentItem = session.value.items[itemIdx.value];
  if (!currentItem) return null;


  if (currentItem.facts.item_type === 'wedding_ring') {
    let additionalItem = {}

    const pairItemIdx = (itemIdx.value == 0) ? 1 : 0;

    if (pairItemIdx >= 0 && pairItemIdx < session.value.items.length) {
      additionalItem = session.value.items[pairItemIdx].image
    }

    return {
      ...currentItem.image,
      additionalItem: additionalItem,
      set: session.value.set
    };
  }

  if (hoveredVariantImage.value) {
    const img = hoveredVariantVariantImage(hoveredVariantImage.value);
    return {
      ...currentItem.image,
      filename: img.filename,
      filename_layer: img.filename_layer,
    };
  }
  return currentItem.image;
});

const hoveredVariantVariantImage = (img: any) => {
  return {
    filename: typeof img === 'string' ? img : (img?.filename || ''),
    filename_layer: typeof img === 'object' ? (img?.filename_layer || '') : '',
  };
};

// Initialize from route/config
const parsedItemIdx = typeof route.params.itemIdx === 'string'
    ? parseInt(route.params.itemIdx, 10)
    : (typeof route.params.itemIdx === 'number' ? route.params.itemIdx : 0);
itemIdx.value = isNaN(parsedItemIdx as number) ? 0 : (parsedItemIdx as number);

if (Config.getViewMode() != '') {
  viewMode.value = Config.getViewMode()
}

watch(itemIdx, (newValue, oldValue) => {
  if (oldValue != newValue) {
    scrollUp()
  }
})

// When engraving section becomes visible, scroll it into view
watch(showEngraving, async (visible) => {
  if (!visible) return;
  await nextTick();
  const el = (engravingEl.value as any)?.$el ?? (engravingEl.value as any);
  if (el && typeof el.scrollIntoView === 'function') {
    el.scrollIntoView({behavior: 'smooth', block: 'end'});
  }
});

const sessionsObj: Sessions = new Sessions();

const scrollUp = (): void => {
  const element = mainContainer.value;
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

const handleKeydown = (e: KeyboardEvent) => {
  if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
    e.preventDefault();
    printout();
  }
};

onMounted(() => {
  // item loading handled by child component IntersectionObservers
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});

if (session.value.session_id !== route.params.sessionId) {
  store.commit("loading/actionStarted");

  sessionsObj
      .get(route.params.sessionId.toString())
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
          checkItemIsOnWishlist();

          setPageTitle()
          setLastSeen();
        }
      });
}

// Watch for route sessionId changes and reload the session when it changes
watch(
    () => route.params.sessionId,
    async (newSessionId, oldSessionId) => {
      if (!newSessionId || newSessionId === oldSessionId) return;

      store.commit("loading/actionStarted");
      try {
        const sessionData: any = await sessionsObj.get(newSessionId.toString());
        store.commit("loading/actionFinished");
        if (typeof sessionData.error !== "undefined") {
          error.value = sessionData.error;
          return;
        }
        // Update store and local refs
        store.commit("session/setFull", sessionData);
        session.value = store.getters["session/get"];

        // Reset indices safely based on current route
        const parsedIdx = typeof route.params.itemIdx === 'string'
            ? parseInt(route.params.itemIdx, 10)
            : (typeof route.params.itemIdx === 'number' ? route.params.itemIdx : 0);
        itemIdx.value = isNaN(parsedIdx as number) ? 0 : (parsedIdx as number);
        imageIdx.value = '-1';

        checkItemIsOnWishlist();
        setPageTitle();
        setLastSeen();
      } catch (e) {
        // Ensure loading state is cleared even on unexpected errors
        store.commit("loading/actionFinished");
        // Optionally log or set a generic error
        // console.error(e);
      }
    }
);

/**
 * set last seen
 */

declare global {
  interface Window {
    addLastSeen?: (itemNumber: string, image: string, linkItemNumber: string) => void
  }
}


const setLastSeen = () => {
  if (window?.addLastSeen) {
    window.addLastSeen?.(
        session.value.session_id,
        `https://items.api.rubin-trauringe.de/images/session/${session.value.session_id}`,
        window.location.href
    )
  }
}

/**
 * wishlist
 */

declare global {
  interface Window {
    addWishlist?: (itemNumber: string, image: string, linkItemNumber: string) => void,
    removeWishlist?: (linkItemNumber: string) => void,
    hasWishlist?: (linkItemNumber: string) => boolean
  }
}

const wishListLinkItemNumber = computed(() => {
      if (session.value?.items[itemIdx.value as string]) {
        return window.location.origin + window.location.pathname + "#/?add=" + session.value.items[itemIdx.value as string].item_number
      } else {
        return ""
      }
    }
)

const addToWishList = () => {
  const itemNumber = session.value.items[itemIdx.value as string].item_number
  const image = `https://items.api.rubin-trauringe.de/image/${session.value.items[itemIdx.value as string].item_number}/main`
  const linkItemNumber = wishListLinkItemNumber.value

  console.debug("addToWishList", itemNumber, image, linkItemNumber)

  if (window?.addWishlist) {
    window?.addWishlist(itemNumber, image, linkItemNumber)
    isOnWishlist.value = true
  }
  isOnWishlist.value = true
}

const checkItemIsOnWishlist = () => {
  isOnWishlist.value = window?.hasWishlist ? window?.hasWishlist(wishListLinkItemNumber.value) : false
}

const isOnWishlist = ref(false)

const toggleItemOnWishList = () => {
  if (isOnWishlist.value) {
    if (window?.removeWishlist) {
      console.debug("removeFromWishlist", wishListLinkItemNumber.value)
      window?.removeWishlist(wishListLinkItemNumber.value)
      isOnWishlist.value = false
    }
  } else (
      addToWishList()
  )
}

const isSecureConftecHost = computed(() => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.includes('ringfabrik.de') || hostname.includes('localhost');
});

/**
 * Set page title
 */

const setPageTitle = () => {
  if (typeof session.value.items[itemIdx.value] !== "undefined") {
    document.title = session.value.items[itemIdx.value].desc.title
  } else {
    document.title = t(pageStr + '.configurator')
  }

}

/**
 *
 */

const imageIdx = ref('-1');
watch(imageIdx, () => {
  scrollUp();
}, {flush: 'post'});

/**
 * order data
 */

const b64EncodeUnicode = (str: string) => {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
}

const orderData = ref("");
const orderForm = ref(null);

const createOrder = () => {
  store.commit("loading/actionStarted");

  sessionsObj
      .get_order_data(session.value.session_id)
      .then((tmpOrderData: any) => {
        if (typeof tmpOrderData.error != "undefined") {
          error.value = tmpOrderData.error;
        } else {
          orderData.value = b64EncodeUnicode(JSON.stringify(tmpOrderData));

          setTimeout(() => {
            orderForm.value?.submit();
          }, 100);
          store.commit("loading/actionFinished");
        }
      });
};

const printout = () => {
  const sid = session.value.session_id;
  if (!sid) return;
  // Use vue-router to resolve the hash URL, then open in a new window/tab
  const routeLocation = router.resolve({name: 'ConfigurationPrintout', params: {sessionId: sid}});
  window.open(routeLocation.href, '_blank');
};

const onShare = async () => {
  try {
    const curItem = session.value?.items?.[itemIdx.value];
    const title = curItem?.desc?.title || curItem?.desc?.short_title || t(pageStr + '.share_configuration');
    const text = t(pageStr + '.check_out_this_configuration');
    const url = window.location?.href || '';

    if (typeof navigator !== 'undefined' && 'share' in navigator) {
      // @ts-ignore - Web Share API may not be in TS lib
      await navigator.share({title, text, url});
      return;
    }

    // Fallback: copy URL to clipboard
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      alert(t(pageStr + '.link_copied_to_clipboard'));
      return;
    }

    // Last-resort fallback
    const tmp = document.createElement('input');
    tmp.value = url;
    document.body.appendChild(tmp);
    tmp.select();
    document.execCommand('copy');
    document.body.removeChild(tmp);
    alert(t(pageStr + '.link_copied_to_clipboard'));
  } catch (e) {
    // Swallow errors; optionally inform the user
  }
};

const loadingVariants = new Set<string>();

const loadItemVariants = async (idx: number, variantIdx?: string, variantIdxAddon: string = "") => {
  if (!session.value || !session.value.items || !session.value.items[idx]) return;
  const item = session.value.items[idx];
  const sessionId = session.value.session_id;

  if (!item.variants) return;

  const variantsToLoad = variantIdx
      ? item.variants.filter((v: any) => v.idx === variantIdx)
      : item.variants;

  const valuePromises = variantsToLoad.map((variant: any) => {

    const key = `${idx}-${variant.idx}`;
    if ((variant.values && variant.values.length > 0) || loadingVariants.has(key)) return Promise.resolve();

    loadingVariants.add(key);
    return sessionsObj.getVariantValues(sessionId, idx, variant.idx, variantIdxAddon)
        .then((data: any) => {
          if (typeof data.error != 'undefined') {
            store.commit("session/removeVariant", {
              itemIdx: idx,
              variantIdx: variant.idx
            });
            session.value = store.getters["session/get"];
            return;
          }


          const isWeddingRing = item.facts?.item_type === 'wedding_ring';
          const isAddOrRemove = variant.idx && (variant.idx.includes('add') || variant.idx.includes('remove'));
          // discs.<n>.width must be kept even with a single value: it's not a real choice
          // but the marker itemV2DiscWidthConfigurator.vue relies on to know the disc exists
          // and to display its current width - this matters most for single-disc rings,
          // where there is often only one possible width value.
          const isDiscWidth = variant.idx && /^discs\.\d+\.width$/.test(variant.idx);
          // discs.<n>.metal/color/finish and grooves.<n>.metal/color/finish must likewise be
          // kept even with a single (fixed, non-selectable) value: itemV2DiscWidthConfigurator.vue
          // and itemV2GrooveConfigurator.vue both rely on the matched value to render the actual
          // disc/groove color in the ring cross-section - without this exemption, that single value
          // is discarded right after being fetched and the cross-section falls back to a generic color.
          const isDiscOrGrooveColorSwatch = variant.idx && /^(discs|grooves)\.\d+\.(metal|color|finish)$/.test(variant.idx);
          // Fixed stone values still describe the preset and its read-only groups.
          const isStoneDisplayVariant = variant.idx && /^stones\.(stone_presets|\d+\.[^.]+)$/.test(variant.idx);
          const keepIfOneValue = isWeddingRing && (isAddOrRemove || isDiscWidth || isDiscOrGrooveColorSwatch || isStoneDisplayVariant) && data.values && data.values.length === 1;

          if (!data.values || (data.values.length < 2 && !keepIfOneValue)) {
            store.commit("session/removeVariant", {
              itemIdx: idx,
              variantIdx: variant.idx
            });
          } else {
            store.commit("session/setVariantValues", {
              itemIdx: idx,
              variantIdx: variant.idx,
              values: data.values
            });
          }
          session.value = store.getters["session/get"];
        })
        .catch(err => {
          console.error(`Failed to load values for variant ${variant.idx}`, err);
          // If variant not found or invalid item index, re-fetch the whole session to refresh stubs
          const errorMsg = err.message || err.error || "";
          const isRefreshError = typeof errorMsg === 'string' && (errorMsg.includes("not found") || errorMsg.includes("index"));

          if (isRefreshError) {
            sessionsObj.get(sessionId).then((sessionData: any) => {
              store.commit("session/setFull", sessionData);
              session.value = store.getters["session/get"];
            });
          } else {
            // If status != 200 remove the variant from the variants list
            store.commit("session/removeVariant", {
              itemIdx: idx,
              variantIdx: variant.idx
            });
            session.value = store.getters["session/get"];
          }

        })
        .finally(() => {
          loadingVariants.delete(key);
        });
  });
  Promise.allSettled(valuePromises);
}

provide("loadItemVariants", loadItemVariants);
provide("itemIdx", itemIdx);
provide("session", session);

// Applies a distinct action/value pair per item in a single request (see Sessions.patchMultiple),
// used e.g. by itemV3StonePresets.vue to apply a stone preset to one item while forcing "no
// stones" on the other items of a set, independent of the global configureAll setting.
// showLoading can be set to false for patches that happen while the user is still actively
// interacting with a field (e.g. typing an engraving text or adding engraving symbols), so the
// full-screen loading animation doesn't block the field and interrupt the user's input.
const patchMultiple = (items: { itemIdx: number, action: string, value: string }[], showLoading = true) => {
  if (showLoading) {
    store.commit("loading/actionStarted");
  }
  sessionsObj.patchMultiple(session.value.session_id, items).then((sessionData: any) => {
    if (showLoading) {
      store.commit("loading/actionFinished");
    }
    if (typeof sessionData.error != "undefined") {
      error.value = sessionData.error;
    } else {
      store.commit("session/setFull", sessionData);
      session.value = store.getters["session/get"];
    }
  });
};

provide("patchMultiple", patchMultiple);

// When set-view (configureAll) is active, a patch is applied to every item of the session
// at once, sent as a list to the same PATCH endpoint (see Sessions.patchSet). Pass
// forceSingleItem=true for patches that are inherently individual per item (e.g. name,
// engraving) and must never be applied to the whole set.
const patch = (action: string, value: any, certificatedDiamond: boolean, forceSingleItem = false) => {
  store.commit("loading/actionStarted");

  const applyToWholeSet = !forceSingleItem && configureAll.value && session.value.items.length > 1;

  const apiCall = applyToWholeSet
      ? sessionsObj.patchSet(
          session.value.session_id,
          value,
          session.value.items.map((_: any, idx: number) => ({itemIdx: idx, valueIdx: action}))
      )
      : sessionsObj.patch(session.value.session_id, itemIdx.value, action, value);

  apiCall.then((sessionData: any) => {
    store.commit("loading/actionFinished");
    if (typeof sessionData.error != "undefined") {
      error.value = sessionData.error;
    } else {
      //if (sessionData.item_idx !== -1) {
      //itemIdx.value = sessionData.item_idx;
      //}
      store.commit("session/setFull", sessionData);
      session.value = store.getters["session/get"];
    }
  });
};

const deleteItem = (idx: number) => {
  store.commit("loading/actionStarted");
  sessionsObj
      .deleteItem(session.value.session_id, idx)
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          const newItemsLength = sessionData.items?.length || 0;
          if (itemIdx.value >= newItemsLength) {
            itemIdx.value = Math.max(0, newItemsLength - 1);
          }
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
        }
      })
      .catch((err) => {
        store.commit("loading/actionFinished");
        console.error("Failed to delete item:", err);
        alert(t('components.itemV2.itemV2ItemWidget.error_deleting'));
      });
};

const addItem = (idx: number) => {
  store.commit("loading/actionStarted");
  sessionsObj
      .addItem(session.value.session_id, idx)
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
          itemIdx.value = idx;
          store.commit("session/setConfigureAll", true);
        }
      })
      .catch((err) => {
        store.commit("loading/actionFinished");
        console.error("Failed to add item:", err);
        alert(t('components.itemV2.itemV2ItemWidget.error_adding'));
      });
};

const patchSet = (value: string, items: { itemIdx: number, valueIdx: string }[]) => {
  store.commit("loading/actionStarted");
  sessionsObj
      .patchSet(session.value.session_id, value, items)
      .then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          store.commit("session/setFull", sessionData);
          session.value = store.getters["session/get"];
        }
      });
}

const currentColor = computed(() => {
  // search on root level
  for (let variantIdx in session.value.items[0].variants) {
    if (session.value.items[0].variants[variantIdx].idx === "color") {
      const variantData = session.value.items[0].variants[variantIdx];
      for (let valueIdx in variantData.values) {
        if (variantData.values[valueIdx].match === true) {
          return variantData.values[valueIdx].idx.toLowerCase();
        }
      }
    }
  }
  // search alternativ
  for (let variantIdx in session.value.items[0].variants) {
    if (session.value.items[0].variants[variantIdx].idx?.includes("color")) {
      const variantData = session.value.items[0].variants[variantIdx];
      for (let valueIdx in variantData.values) {
        if (variantData.values[valueIdx].match === true) {
          return variantData.values[valueIdx].idx.toLowerCase();
        }
      }
    }
  }
  return "";
});

/**
 * Diamantbörse
 */

const addCertificatedDiamond = () => {
  let baseUrl = "/"

  if (window.__CONFIGURATOR_PROPS__) {
    baseUrl = window.__CONFIGURATOR_PROPS__.baseUrl
  }

  window.location.href = baseUrl + session.value.session_id + "/diamonds";
};

const isDiamondExchangeUsable = computed(() => {
  return session.value.items[parseInt(itemIdx.value.toString())]?.facts.biggest_stone >= 0.3
})

/**
 * Stone types
 */

const getStoneTypes = computed(() => {
  const stoneTypes = []
  if (session.value.items[itemIdx.value]?.variants) {
    for (const variantsIdx in session.value.items[itemIdx.value]?.variants) {
      const variantsData = session.value.items[itemIdx.value]?.variants[variantsIdx]
      if (variantsData?.idx?.includes("stone_type")) {
        stoneTypes.push(variantsData)
      }
    }
  }
  return stoneTypes
})

/**
 * view mode
 */

const showStepWidget = () => {
  nextTick(() => {
    activeWidget.value = 'step'
  });
}

</script>
